import { FC, useEffect, useState } from 'react'

import { ButtonGroup, HStack } from '@chakra-ui/react'
import { ToolbarRotateIcon, ToolbarScaleIcon, ToolbarTranslateIcon } from '@editor/assets/icons'
import { TransformTypes } from '@editor/interfaces/interfaces'
import { BlueprintEditorTools } from '@editor/pages/projects/blueprint-editor/definitions'
import { useAppSelector } from '@editor/store/app'
import { isTablet } from 'react-device-detect'

import SubToolbarButton from './components/SubToolbarButton'

const SubToolbar: FC = () => {
  // Store
  const message = useAppSelector((state) => state.attentionText.message)
  const selectedTool = useAppSelector((state) => state.blueprint.editor.selectedTool)

  // States
  const [topOffset, setTopOffset] = useState<string | number>(1)

  /**
   * Adjust top offset when message changes.
   */
  useEffect(() => {
    const canvas = document.getElementById('canvasBox')

    // There's an attention text visible
    const ele = document.getElementById('attention-text')
    if (message && ele && canvas) {
      const canvasRect = canvas.getBoundingClientRect()
      const eleRect = ele.getBoundingClientRect()
      setTopOffset(`${eleRect.bottom - canvasRect.top + 10}px`)
      return
    }

    // Otherwise based it off blueprint switcher
    const switcher = document.getElementById('blueprint-view-switcher-container')
    if (switcher && canvas) {
      const canvasRect = canvas.getBoundingClientRect()
      const switcherRect = switcher.getBoundingClientRect()
      setTopOffset(`${switcherRect.bottom - canvasRect.top + 10}px`)
      return
    }

    setTopOffset('10px')
  }, [message])

  if (selectedTool !== BlueprintEditorTools.MaskPCD) return null

  return (
    <HStack
      left={isTablet ? '600px' : '50%'}
      transform="translateX(-50%)"
      overflow="hidden"
      position="absolute"
      gap={4}
      top={topOffset}
    >
      <ButtonGroup attached>
        <SubToolbarButton
          icon={<ToolbarTranslateIcon width="1.5em" height="1.5em" />}
          label="移動"
          toolType={TransformTypes.TRANSLATE}
        />
        <SubToolbarButton
          icon={<ToolbarScaleIcon width="1.5em" height="1.5em" />}
          label="サイズ"
          toolType={TransformTypes.SCALE}
        />
        <SubToolbarButton
          icon={<ToolbarRotateIcon width="1.5em" height="1.5em" />}
          label="回転"
          toolType={TransformTypes.ROTATE}
        />
      </ButtonGroup>
    </HStack>
  )
}

export default SubToolbar
